export const ErrorIcon = () => {
	return (
		<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="32" cy="32" r="32" fill="url(#paint0_linear_996_1506)" fillOpacity="0.5" />
			<path
				d="M31.7396 40.9284C31.4706 40.8835 31.2464 40.9732 31.1119 41.1525L27.4354 44.829C26.718 45.5464 25.8213 46.0844 24.835 46.2638C23.1761 46.5776 21.562 46.0844 20.3963 44.9187C19.4547 43.9772 18.9615 42.7666 18.9615 41.4664C18.9615 40.1662 19.4547 38.9108 20.3963 38.0141L26.7629 31.6475C27.9734 30.4369 29.6772 29.9437 31.3809 30.3472C31.8741 30.4817 32.3673 30.6611 32.7708 30.9301C33.3537 31.2888 33.8468 31.7371 34.2055 32.2752C34.5194 32.7235 35.1022 32.8132 35.5057 32.4545C35.5506 32.4545 35.5506 32.4097 35.5506 32.4097C35.9093 32.1407 35.9989 31.6026 35.7299 31.2439C35.2367 30.4817 34.5194 29.8092 33.7123 29.316C33.1743 29.0022 32.6363 28.7332 32.0086 28.5987C29.6772 28.0158 27.3457 28.6883 25.7317 30.3024L18.9167 37.0277C16.3611 39.5833 16.3611 43.7081 18.9167 46.2189C20.1273 47.4295 21.7862 48.1468 23.5347 48.1468C25.2833 48.1468 26.8974 47.4743 28.1528 46.2189L32.2328 42.1389C32.6363 41.7354 32.3673 40.9732 31.7396 40.9284Z"
				fill="#D3603B"
			/>
			<path
				d="M37.2095 35.8171C36.9405 35.5032 36.4922 35.4135 36.0886 35.6377C35.0126 36.2654 33.7124 36.4447 32.4121 36.1309C31.8741 35.9964 31.3809 35.7722 30.9326 35.4584C30.4394 35.0997 29.991 34.6962 29.6324 34.203C29.3185 33.7546 28.7357 33.7098 28.3321 34.0236C28.2873 34.0236 28.2873 34.0685 28.2425 34.0685C27.9286 34.3375 27.839 34.8755 28.0631 35.2342C28.2873 35.5929 28.5563 35.9067 28.8702 36.2206C30.0807 37.4311 31.7396 38.1485 33.4882 38.1485C34.7436 38.1485 35.9541 37.7898 36.9853 37.1173C37.4337 36.8483 37.5234 36.2654 37.2095 35.8171Z"
				fill="#D3603B"
			/>
			<path
				d="M40.9308 25.2809C40.8412 25.7292 41.1102 26.2224 41.5585 26.3121L41.693 26.3569C42.1862 26.4914 42.7243 26.1776 42.8139 25.6844C43.6658 21.6941 42.9484 18.9143 40.617 17.3899C40.4377 17.2554 39.8548 16.9415 39.6755 16.807C38.7339 16.3138 37.6579 16 36.5818 16C34.2056 16 31.919 16.6725 30.3946 19.4075L27.7941 24.2945C27.4354 24.9222 27.9735 25.7292 28.7357 25.5947C28.7805 25.5947 28.8253 25.5947 28.8253 25.5947C29.1392 25.5499 29.4082 25.3706 29.5427 25.1016L32.0086 20.5284C32.8605 18.9591 34.5194 17.9728 36.3128 17.9728C37.1199 17.9728 37.9269 18.1969 38.6891 18.5556C40.3928 19.5868 41.7827 21.1112 40.9308 25.2809Z"
				fill="#D3603B"
			/>
			<path
				d="M44.4728 29.9886L46.6697 29.8989C47.1629 29.8989 47.5216 29.4954 47.4767 29.0022C47.4319 28.509 47.0732 28.1504 46.58 28.1952L44.3831 28.2849C43.8899 28.2849 43.5312 28.6884 43.576 29.1816C43.6209 29.6748 43.9796 30.0334 44.4728 29.9886Z"
				fill="#D3603B"
			/>
			<path
				d="M48.4631 34.2481L43.9347 32.4098C43.4864 32.2305 42.9932 32.4546 42.8139 32.903C42.6345 33.3514 42.8587 33.8445 43.3071 34.0239L47.8354 35.8621C48.2838 36.0415 48.7769 35.8173 48.9563 35.3689C49.0908 34.9206 48.9115 34.4274 48.4631 34.2481Z"
				fill="#D3603B"
			/>
			<path
				d="M42.4104 35.7275C42.0965 35.3689 41.5585 35.3689 41.1998 35.6827C40.8411 35.9965 40.8411 36.5346 41.155 36.8932L43.1726 39.0005C43.4864 39.3592 44.0244 39.3592 44.3831 39.0453C44.7418 38.7315 44.7418 38.1935 44.428 37.8348L42.4104 35.7275Z"
				fill="#D3603B"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_996_1506"
					x1="32"
					y1="0"
					x2="32"
					y2="64"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#FFCCBC" />
					<stop offset="1" stopColor="#FFAB91" />
				</linearGradient>
			</defs>
		</svg>
	);
};
